enum ECookie {
	essentials = 'essentialsConsent',
	sentry = 'sentryConsent',
	mouseflow = 'mouseflowConsent',
	analytics = 'analyticsConsent',
	hasSelectedCookies = 'hasSelectedCookies',
	isReloadNeeded = 'isReloadNeeded'
}

export { ECookie };
